import React, { useContext } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import GroupBiorepositoryOps from "../FieldTags/GroupBiorepositoryOps";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const reasons = [
    "Withdrawal of consent",
    "Retention term expiry",
    "Utilization review decision",
    "Sample damaged, compromised",
    "No label on sample, unable to be identified",
    "Insufficient contents (DNA/RNA/cells)",
    "Parent sample consumed, block exhausted",
    "Other (specify below)",
];

const DisposalReason = ({ disposalReason, handleChange, pullLists }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, ROLES.ELEVATED);

    return (
        <div className="planField">
            <GroupBiorepositoryOps />
            <FormControl variant="standard">
                <InputLabel shrink={true}>{pullListLabels.disposalReason}</InputLabel>
                <Select
                    id="disposalReason-field"
                    name="disposalReason"
                    notched={true}
                    value={disposalReason}
                    onChange={(e) => handleChange("disposalReason", e.target.value)}
                    disabled={!canEdit}
                >
                    {reasons.map((menuReason) => (
                        <MenuItem
                            key={menuReason}
                            value={menuReason}
                        >
                            {menuReason}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <HistoryLogElement pullLists={pullLists} label={"disposalReason"} />
        </div>
    );
};

export default DisposalReason;